import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { List, Map } from 'immutable'
import { useTranslation } from '../../../services/static-text/hooks'
import { selectTokenProcessing, selectPaymentAuthorized } from '../../../services/payment/selectors'
import { selectCheckoutHasError } from '../../../services/checkout/selectors'
import { getCancelAccountHelpUrl, getHelpCenterUrl, isGift } from '../../../services/url/index'
import { pushHistory } from '../../../services/navigation/actions'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import { useNextGiftRoute } from '../../../services/gift/utils/index'
import { TARGET_BLANK } from '../../Link/constants'
import { GiftLoading } from '../GiftLoading/index'
import ErrorMessage from '../../ErrorMessage/index'
import AdyenDropIn from '../../AdyenDropIn/index'
import Link from '../../Link/index'

import { PaymentEncryptionMessage } from './PaymentEncryptionMessage'
import { GIFT_PAYMENT_PAGE_STATIC_KEY } from './gift-payment-page-static-key'

const CreditCardDisclamer = () => {
  const translateByKey = useTranslation(GIFT_PAYMENT_PAGE_STATIC_KEY)
  const userPrimaryLanguage = useSelector(selectPrimaryLanguage)
  return (
    <span className="cart-payment-v2__disclaimer">
      {!isGift && (
        <React.Fragment>
          {translateByKey('disclaimerIntroStart')}
          <Link
            className="cart-payment-v2__disclaimer-link"
            directLink
            to={getCancelAccountHelpUrl(userPrimaryLanguage)}
            target={TARGET_BLANK}
          >
            {translateByKey('disclaimerLink')}
          </Link>
          {translateByKey('disclaimerIntroEnd')}
        </React.Fragment>
      )}
    </span>
  )
}

const OrderError = () => {
  const userLanguage = useSelector(selectPrimaryLanguage)
  const translatePayment = useTranslation('cartPaymentPageV2')
  const orderErrorMessages = [
    translatePayment('errorPayment'),
    <Link
      className="cart-payment-v2__billing-error-link"
      key={getHelpCenterUrl(userLanguage)}
      to={getHelpCenterUrl(userLanguage)}
      target={TARGET_BLANK}
      directLink
    >{translatePayment('customerSupport')}
    </Link>,
  ]
  return (
    <ErrorMessage
      errorMessages={orderErrorMessages}
      errorMessageClass={['cart-payment-v2__billing-error']}
    />
  )
}

export const CreditCardPayment = (props) => {
  const { selectedPlan = Map() } = props
  const translateByKey = useTranslation(GIFT_PAYMENT_PAGE_STATIC_KEY)
  const isPaymentAuthorized = useSelector(selectPaymentAuthorized)
  const errorShouldRender = useSelector(selectCheckoutHasError)
  const tokenProcessing = useSelector(selectTokenProcessing)

  const getNextRoute = useNextGiftRoute()
  const dispatch = useDispatch()

  useEffect(() => {
    if (isPaymentAuthorized && !tokenProcessing) {
      const nextRoute = getNextRoute({ subRoute: 'review' })
      dispatch(pushHistory({
        scrollToTop: true,
        url: nextRoute,
      }))
    }
  }, [
    isPaymentAuthorized,
    tokenProcessing,
    getNextRoute,
  ])

  return (
    <div className="credit-card-payment">
      <GiftLoading visible={tokenProcessing} />
      <PaymentEncryptionMessage />
      {errorShouldRender && <OrderError />}
      <AdyenDropIn
        submitButtonText={
          tokenProcessing
            ? `${translateByKey('processing')}...`
            : translateByKey('confirmPay')
        }
        disclaimer={<CreditCardDisclamer />}
        parentProcessing={tokenProcessing}
        error={errorShouldRender}
        isResetOnUnmount={false}
        isGift
        planCost={selectedPlan.get('costs', List()).first() || 0}
      />
    </div>
  )
}

export default CreditCardPayment
